import { CloneTableToolbar } from '@/features/shared/components/cloneTable/CloneTableToolbar';
import {
  cloneColumnOptions,
  cloneDefaultColumnVisibilityModel,
  cloneDefaultSortDirection,
  cloneDefaultSortKey,
  type CloneSortDirection,
  type CloneSortKey,
  cloneSortOptions,
  cloneStatusOptions,
} from '@/features/suites/pages/suitesPageCloneConfig';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteExecutionStatus } from '@flowqa/shared';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type SuitesCloneToolbarProps = {
  onDebouncedCloneSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: CloneSortKey;
  sortDirection: CloneSortDirection;
  onSortChange: (sortKey: CloneSortKey, sortDirection: CloneSortDirection) => void;
  filterStatuses: SuiteExecutionStatus[];
  onFilterStatusesChange: (next: SuiteExecutionStatus[]) => void;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
};

export const SuitesCloneToolbar = (props: SuitesCloneToolbarProps): ReactElement => (
  <CloneTableToolbar<CloneSortKey, SuiteExecutionStatus>
    title="Suites"
    searchAriaLabel="Search suites, tags"
    defaultColumnVisibilityModel={cloneDefaultColumnVisibilityModel}
    columnOptions={cloneColumnOptions}
    defaultSortKey={cloneDefaultSortKey}
    defaultSortDirection={cloneDefaultSortDirection}
    sortOptions={cloneSortOptions}
    statusOptions={cloneStatusOptions}
    {...props}
  />
);

export type { CloneDateQuickFilter };
